import { authApi } from "@/api";
import WebApp from "@twa-dev/sdk";
import { AxiosResponse } from "axios";

const ACCESS_TOKEN_KEY = 'refresh_token';
const REFRESH_TOKEN_KEY = 'access_token';

class JwtService {
    isRefreshTokenWasUsed = false;
    refreshTokenRequest: Promise<AxiosResponse> | null = null

    getAccessToken() {
        return window.localStorage.getItem(ACCESS_TOKEN_KEY);
    }

    getRefreshToken() {
        return window.localStorage.getItem(REFRESH_TOKEN_KEY);
    }

    initToken() {
        if (!WebApp.initData.length) {
            let token = this.getAccessToken()
            if (process.env.NODE_ENV === 'development') {
                if (!process.env.REACT_APP_TEST_TOKEN_KEY)
                    throw new Error('Установи токен в переменную REACT_APP_TEST_TOKEN_KEY');
                token = process.env.REACT_APP_TEST_TOKEN_KEY
            }
            if (token) this.setAccessToken(token);
        }
    }

    setAccessToken(token: string) {
        window.localStorage.setItem(ACCESS_TOKEN_KEY, token);
    }

    setRefreshToken(token: string) {
        window.localStorage.setItem(REFRESH_TOKEN_KEY, token);
    }

    destroyTokenPair() {
        window.localStorage.removeItem(ACCESS_TOKEN_KEY);
        window.localStorage.removeItem(REFRESH_TOKEN_KEY);
    }

    getRefreshTokenWasUsedState(): boolean {
        return this.isRefreshTokenWasUsed
    }

    setRefreshTokenWasUsedState(val: boolean) {
        this.isRefreshTokenWasUsed = val
    }

    getRefreshTokenRequest(): Promise<AxiosResponse> | null {
        return this.refreshTokenRequest
    }

    setRefreshTokenRequest(val: Promise<AxiosResponse> | null) {
        this.refreshTokenRequest = val
    }

    getAuthHeader() {
        return WebApp.initData.length ? WebApp.initData : `Bearer ${this.getAccessToken()}`
    }
}

export const jwtService = new JwtService();
// @ts-ignore
window.jwtService = jwtService
